import { PILLARS } from "../data/content";

export default function Pillars() {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="relative py-24 md:py-32 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-4">
              / 01 — Pillars
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-slate-50">
              Three pillars.
              <br />
              <span className="text-slate-500">One unified system.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 flex items-end">
            <p className="text-base md:text-lg text-slate-400 leading-relaxed max-w-xl">
              Every solution we deploy is engineered to deliver on Safety, Security
              and Intelligence — the foundations of mission-critical operations.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {PILLARS.map((p, idx) => (
            <div
              key={p.label}
              data-testid={`pillar-${p.label.toLowerCase()}`}
              className="bg-slate-950 p-8 md:p-10 group hover:bg-slate-900 transition-colors duration-500"
            >
              <div className="flex items-baseline justify-between mb-8">
                <span className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono">
                  P/0{idx + 1}
                </span>
                <span className="text-5xl font-light text-slate-800 group-hover:text-cyan-400/30 transition-colors">
                  0{idx + 1}
                </span>
              </div>
              <h3 className="text-2xl font-medium text-slate-50 mb-1 tracking-tight">
                {p.label}
              </h3>
              <div className="h-px w-12 bg-cyan-400 my-5 group-hover:w-24 transition-all duration-500" />
              <p className="text-base text-slate-300 leading-relaxed mb-3 font-medium">
                {p.title}
              </p>
              <p className="text-sm text-slate-500 leading-relaxed">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
